import { Text, Tooltip } from '@pairy/pds-react';
import Image from 'next/image';

import handleFreeBadgeLinkOpen from '../../../../utils/handleFreeBadgeLinkOpen';

import * as Styled from './index.styles';

interface Props {
  userSubscriptionPlan: string;
  isMobile?: boolean;
}

/*
 * Free 플랜 배지.
 * 뷰어 배경(콘텐츠 영역)이 아니라 슬라이드(페이지 박스) 기준으로 배치되어야 하므로
 * 반드시 페이지 요소 내부에서 렌더한다.
 */
const SlideFreeBadge = ({ userSubscriptionPlan, isMobile = false }: Props) => {
  if (userSubscriptionPlan !== 'Free') {
    return null;
  }

  return (
    <Tooltip content="세일즈클루로 공유된 문서입니다" side="top" align="end">
      <Styled.Container
        className={isMobile ? 'is-mobile' : ''}
        gap={isMobile ? 6 : 8}
        padding={isMobile ? { x: 12, y: 8 } : { x: 16, y: 12 }}
        alignItems="center"
        width="fit-content"
        onClick={(e) => {
          e.stopPropagation();
          handleFreeBadgeLinkOpen();
        }}
      >
        <Text
          variant={isMobile ? 'sm-semibold' : 'lg-semibold'}
          color="skyblue_100"
        >
          Powered by
        </Text>
        <Image
          src="/images/salesclue_logo_black_mono.png"
          width={isMobile ? 75 : 94}
          height={isMobile ? 17 : 21}
          alt={'SalesClue'}
          unoptimized
        />
      </Styled.Container>
    </Tooltip>
  );
};

export default SlideFreeBadge;
